module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.nalaganje) ? _c('div', [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [(_vm.points / _vm.maxPoints > 0.75) ? _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok",
    staticStyle: {
      "color": "#0073b7"
    }
  })]) : _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok",
    staticStyle: {
      "color": "#f39c12"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.achievvedPoints")))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.points) + "/" + _vm._s(_vm.maxPoints))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.ratingChange")))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.oldRating) + " "), _c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v(" " + _vm._s(_vm.newRating))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [(_vm.newRatingDeviation <= 70) ? _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    staticStyle: {
      "color": "#0073b7"
    }
  })]) : (_vm.newRatingDeviation <= 180) ? _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    staticStyle: {
      "color": "#f39c12"
    }
  })]) : _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    staticStyle: {
      "color": "#dd4b39"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.ratingAccuracy")))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(Math.round((1 - _vm.oldRatingDeviation / 350) * 100)) + " "), _c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v(" " + _vm._s(Math.round((1 - _vm.newRatingDeviation / 350) * 100)) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12 clickable"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.viewYourAnswers")))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "info-box",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showQuestions($event)
      }
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-number",
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.viewYourAnswers")))])])])])])]), _vm._v(" "), (!_vm.toggleLeaderboard) ? _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [(!_vm.toggleLeaderboard) ? _c('span', {
    staticClass: "info-box-icon bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  })]) : _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }), _vm._v(" "), (!_vm.toggleLeaderboard) ? _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.completeMoreQuizes")))]) : _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.joinedLeaderboard")))]), _vm._v(" "), (!_vm.toggleLeaderboard) ? _c('div', {
    staticClass: "progress-leaderboard"
  }, [_c('div', {
    staticClass: "progress-bar-eighty"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-leaderboard",
    style: ('width: ' + (1 - _vm.latestRatingDeviation / 350) * 100 + '%; background: #0073b7')
  })]) : _vm._e(), _vm._v(" "), (!_vm.toggleLeaderboard) ? _c('span', {
    staticClass: "progress-description"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.yourRatingIsInaccurate")) + " "), _c('b', [_vm._v("75%")])]) : _c('span', {
    staticClass: "progress-description"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.improveRating")))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.leaderboard")))]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), (_vm.leaderboard.length > 0) ? _c('div', {
    attrs: {
      "id": "leaderboard"
    }
  }, [_c('div', {
    staticClass: "ribbon"
  }), _vm._v(" "), _c('table', _vm._l((_vm.leaderboard.slice(0, 6)), function(user, index) {
    return _c('tr', {
      key: user.username
    }, [(user.place) ? _c('td', {
      staticClass: "number"
    }, [_vm._v(_vm._s(user.place + 1))]) : _c('td', {
      staticClass: "number"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (user.place) ? _c('td', {
      staticClass: "name",
      staticStyle: {
        "font-weight": "bold",
        "color": "#00a65a"
      }
    }, [_vm._v(_vm._s(user.username))]) : _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(user.username))]), _vm._v(" "), (user.place) ? _c('td', {
      staticClass: "points"
    }, [_vm._v(_vm._s(user.ratingGlicko))]) : _c('td', {
      staticClass: "points"
    }, [_vm._v("\n                " + _vm._s(user.ratingGlicko) + "\n                "), (index == 0) ? _c('img', {
      staticClass: "gold-medal",
      attrs: {
        "src": "https://github.com/malunaridev/Challenges-iCodeThis/blob/master/4-leaderboard/assets/gold-medal.png?raw=true",
        "alt": "gold medal"
      }
    }) : _vm._e()])])
  }), 0)]) : _c('div', [_c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.leaderboardEmpty')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.ratingHistory")))]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('line-chart', {
    attrs: {
      "height": 125,
      "options": {
        scales: {
          yAxes: [{
            ticks: {
              max: _vm.max,
              min: _vm.min
            }
          }]
        }
      },
      "chartData": _vm.zgodovinaRatinga
    }
  })], 1)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-stats",
    staticStyle: {
      "color": "#0073b7"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ranking")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2c2f8f9e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c2f8f9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/RatingExamResults.vue
// module id = 1391
// module chunks = 1